var _g, _path, _g2, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 1000,
    fill: "#d6443e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.7352294532574319,-0.7352294532574319)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 337 337",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 1000,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.24777232574774644,0.24777232574774644)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 336.5044553485045 336.5044553485045",
    height: 336.5044553485045,
    width: 336.5044553485045,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 336.5044553485045 336.5044553485045",
    height: 336.5044553485045,
    width: 336.5044553485045,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 168.252c0-92.923 75.329-168.252 168.252-168.252 92.923 0 168.252 75.329 168.252 168.252 0 92.923-75.329 168.252-168.252 168.252-92.923 0-168.252-75.329-168.252-168.252zM168.252 319.23c83.382 0 150.977-67.595 150.978-150.978 0-83.382-67.595-150.977-150.978-150.977-83.382 0-150.977 67.595-150.977 150.977 0 83.382 67.595 150.977 150.977 150.978z",
    "data-fill-palette-color": "tertiary",
    stroke: "transparent"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 161.52213856728216,
    ry: 161.52213856728216,
    cx: 168.25222767425225,
    cy: 168.25222767425225,
    stroke: "transparent",
    strokeWidth: 0,
    fillOpacity: 1,
    "data-fill-palette-color": "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,63.917046906607126,72.4730070606737)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.67036153529025 191.55844122715712",
    height: 191.55844122715712,
    width: 208.67036153529025,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.67036153529025 191.55844122715712",
    height: 191.55844122715712,
    width: 208.67036153529025,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.67036153529025 191.55844122715712",
    height: 191.55844122715712,
    width: 208.67036153529025,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.67036153529025 191.55844122715712",
    height: 191.55844122715712,
    width: 208.67036153529025,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.67036153529025 191.55844122715712",
    height: 191.55844122715712,
    width: 208.67036153529025,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 208.67036153529025 191.55844122715712",
    height: 191.55844122715712,
    width: 208.67036153529025,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 208.67036153529025,
    viewBox: "0.6499999761581421 -40 43.89999771118164 40.29999923706055",
    height: 191.55844122715712,
    "data-palette-color": "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25-25.4L10.1-25.4 10.1-7.2Q10.1-5.9 10.65-5.2 11.2-4.5 13-4.5L13-4.5 14.3-4.5Q16.25-4.5 16.15-2.2L16.15-2.2Q16.15 0.15 14.3 0.15L14.3 0.15 12.65 0.15Q11.05 0.15 9.65-0.28 8.25-0.7 6.95-1.5L6.95-1.5 6.95-1.45Q4.5-3.05 4.5-7.15L4.5-7.15 4.5-25.4 2.55-25.4Q0.75-25.4 0.65-27.75L0.65-27.75Q0.65-30.1 2.55-30.1L2.55-30.1 4.5-30.1 4.5-35.45Q4.5-37.85 7.35-37.85L7.35-37.85Q10.1-37.85 10.1-35.45L10.1-35.45 10.1-30.1 14.25-30.1Q16.2-30.1 16.1-27.75L16.1-27.75Q16.1-25.4 14.25-25.4L14.25-25.4ZM26-25.4L26-2.1Q26 0.3 23.25 0.3L23.25 0.3Q20.5 0.3 20.5-2.1L20.5-2.1 20.5-37.6Q20.5-40 23.25-40L23.25-40Q26-40 26-37.6L26-37.6 26-30.1 36.55-30.1Q39.1-30.1 41.85-28.2L41.85-28.2Q44.55-26.3 44.55-22.2L44.55-22.2 44.55-2.1Q44.55 0.3 41.8 0.3L41.8 0.3Q39.05 0.3 39.05-2.1L39.05-2.1 39.05-21.75Q39.05-23.05 38.25-24.25L38.25-24.25 38.3-24.2Q37.65-25.4 35.65-25.4L35.65-25.4 26-25.4Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffffff",
    className: "undefined-text-0",
    "data-fill-palette-color": "quaternary",
    id: "text-0"
  })))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336.5044553485045,
    height: 336.5044553485045,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c8f4fc3ea21c99d997b268bf66ba786.svg";
export { ForwardRef as ReactComponent };